module.exports = __webpack_public_path__ + "img/sodo.194e0896.png";